<template>
  <!--begin::Wrapper-->
  <div id="dnn_ctr464_ModuleContent" class="DNNModuleContent ModDNNHTMLC">
    <div id="dnn_ctr464_HtmlModule_lblContent" class="Normal">
      <div class="pageBg">
        <div class="pageBgInner mt-10" data-aos="fade-up">
          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div v-if="loading"
                     class="row justify-content-center bg-white rounded shadow-sm p-10 p-lg-15 mt-20 mx-auto">

                  <div class="col-md-4 mb-5 text-center">
                    <free-style-shimmer :is-loading="true" height="100px" width="100px"
                                        border-radius="50px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-12 text-center mb-10"></div>
                  <div class="col-md-4 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-12 text-center mb-10"></div>
                  <div class="col-md-4 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-md-4 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px" class="w-100"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-md-4 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-12 text-center mb-10"></div>
                  <div class="col-md-6 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-md-6 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px" class="w-100"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-12 text-center mb-10"></div>
                  <div class="col-md-6 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-md-6 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-12 text-center mb-10"></div>
                  <div class="col-md-4 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-md-4 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px" class="w-100"
                                        color="#bdbdbd" />
                  </div>
                  <div class="col-md-4 mb-10 text-center">
                    <free-style-shimmer :is-loading="true" height="10px" width="200px"
                                        color="#bdbdbd" />
                  </div>
                </div>
                <div v-if="!loading" class=" bg-white rounded shadow-sm p-10 p-lg-15 mt-20 mx-auto">
                  <!--begin::Form-->
                  <Form
                    class="form w-100"
                    id="kt_login_signin_form"
                    @submit="onSubmitLogin"
                    :validation-schema="login"
                  >
                    <!--begin::Heading-->
                    <div class="text-center mb-10">
                                                    <span v-if="!image" class="symbol symbol-70px symbol-circle me-6">
                                                      <span class="bg-light-danger symbol-label symbol-label">
                                                        <span class="svg-icon svg-icon-1 svg-icon-danger">
                                                                <i
                                                                  class="uil uil-user fs-1 text-danger button_icon"></i>
                                                        </span>
                                                      </span>
                                                    </span>
                      <span v-if="image" class="symbol symbol-70px symbol-circle me-6">
                                                      <span class="bg-light-danger symbol-label symbol-label">
                                                        <span class="svg-icon svg-icon-1 svg-icon-danger">
                                                                <img
                                                                  :src="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+image)"
                                                                  style="border-radius: 50%;width: 70px;height: 70px"
                                                                  alt="">
                                                        </span>
                                                      </span>
                                                    </span>
                      <!--begin::Title-->
                      <h1 class="text-dark mt-5 mb-3">{{ $t("profile") }}</h1>
                      <!--end::Title-->
                    </div>
                    <!--begin::Heading-->

                    <div class="row">
                      <div class="col-md-4">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("first_name") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="text"
                            v-model="first_name"
                            name="first_name"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="first_name" />
                              <ErrorMessage name="personalInformation.firstName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-4">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("middle_name") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="text"
                            v-model="middle_name"
                            name="middle_name"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="middle_name" />
                              <ErrorMessage name="personalInformation.middleName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-4">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder text-dark">{{ $t("last_name") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="text"
                            v-model="last_name"
                            name="last_name"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="last_name" />
                              <ErrorMessage name="personalInformation.lastName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("ssn") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="text"
                            v-model="ssn" :disabled="true"
                            name="ssn"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="ssn" />
                              <ErrorMessage name="personalInformation.nationalId" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("phone") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="tel"
                            v-model="phone" :disabled="false"
                            name="phone"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="phone" />
                              <ErrorMessage name="personalInformation.countryCode" />
                              <ErrorMessage name="personalInformation.phoneNumber" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("email") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="email"
                            v-model="email" :disabled="true"
                            name="email"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="email" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->

                      </div>
                      <div class="col-md-6">

                        <label class="form-label fs-6 fw-bolder required text-dark">{{
                            $t("image") }}</label>
                        <div class="d-flex flex-wrap">
                          <button type="button" class="btn btn-dark btn-sm"
                                  :class="!image ? 'w-100' : 'w-100'"
                                  @click="triggerClickUpdate()">
                            <!---->
                            <input type="file"
                                   name="image"
                                   ref="fileImage"
                                   accept="image/jpeg, image/png, image/jpg"
                                   class="d-none"
                                   @change="handleChangeImage($event)"
                                   id="imageFile">
                            <!---->
                            <span> <i class="uil uil-image text-white button_icon"></i> {{ $t("upload_image") }} </span>
                          </button>
                          <div class="d-flex flex-column w-100 me-2 mb-5"
                               v-if="ImageLoaderProgress">
                            <div class="d-flex flex-stack mb-2"><span
                              class="text-muted me-2 fs-7 fw-bold">{{ ImageLoaderProgress }}% </span>
                            </div>
                            <div class="progress h-6px w-100">
                              <div class="progress-bar bg-danger progress-bar-striped progress-bar-animated"
                                   role="progressbar"
                                   :aria-valuenow="ImageLoaderProgress"
                                   aria-valuemin="0" aria-valuemax="100"
                                   :style="{width: ImageLoaderProgress+'%'}"></div>
                            </div>
                          </div>
                          <a v-if="image"
                             :href="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+image)"
                             target="_blank"
                             class="fs-6 text-primary">
                            {{ $t("show_image") }}
                          </a>
                        </div>

                        <Field
                          class="form-control form-control-lg form-control-solid"
                          type="hidden"
                          v-model="image"
                          name="personalInformation.image"
                          :rules="{required:true}"
                          :label="$t('image')"
                          autocomplete="off"
                        />
                        <div class="fv-plugins-message-container">
                          <div class="fv-help-block">
                            <ErrorMessage name="personalInformation.image" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="!insideEgypt">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("dob") }}</label>
                          <Field v-model="dob" name="dob"
                                 v-slot="{ field }">
                            <flat-pickr v-bind="field" name="dob"
                                        class="form-control form-control-lg form-control-solid text-center w-100"
                                        v-model="dob"
                                        :config="{maxDate: 'today'}" />
                          </Field>
                          <!--begin::Input-->
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="dob" />
                              <ErrorMessage name="personalInformation.dob" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->

                      </div>
                      <div class="col-md-6" v-if="!insideEgypt">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("nationality") }}</label>
                          <!--end::Label-->
                          <el-select name="nationality" filterable class="w-100"
                                     v-model="nationality"
                                     :placeholder="$t('choose')">
                            <el-option
                              v-for="(_nationality,key) in nationalities"
                              :value="_nationality.id"
                              :label="i18n.locale.value == 'ar' ? _nationality.value_ar : _nationality.value_en" />
                          </el-select>

                          <Field v-model="nationality" name="nationality" type="hidden"
                                 class="d-none" />
                          <!--begin::Input-->
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="nationality" />
                              <ErrorMessage name="personalInformation.nationality" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6" v-if="!insideEgypt">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("gender") }}</label>
                          <!--end::Label-->
                          <el-select name="gender" filterable class="w-100" v-model="gender"
                                     :placeholder="$t('choose')">
                            <el-option v-for="(_gender,key) in $constants.gendersMap"
                                       :value="key"
                                       :label="i18n.locale.value == 'ar' ? _gender : key" />
                          </el-select>

                          <Field v-model="gender" name="gender" type="hidden" class="d-none" />
                          <!--begin::Input-->
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="gender" />
                              <ErrorMessage name="personalInformation.gender" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
<!--                      <div class="col-md-6" v-if="nationality == 'Egyptian'">-->
<!--                        <div class="fv-row mb-2">-->
<!--                          &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                          <label class="form-label fs-6 fw-bolder text-dark">{{ $t("governorate") }}</label>-->
<!--                          &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                          <el-select name="governorate" filterable class="w-100"-->
<!--                                     v-model="governorate"-->
<!--                                     :placeholder="$t('choose')">-->
<!--                            <el-option-->
<!--                              v-for="(_governorate,key) in $constants.governoratesMap"-->
<!--                              :value="key"-->
<!--                              :label="i18n.locale.value == 'ar' ? _governorate : key" />-->
<!--                          </el-select>-->

<!--                          <Field v-model="governorate" name="governorate" type="hidden"-->
<!--                                 class="d-none" />-->
<!--                          &lt;!&ndash;begin::Input&ndash;&gt;-->
<!--                          &lt;!&ndash;end::Input&ndash;&gt;-->
<!--                          <div class="fv-plugins-message-container">-->
<!--                            <div class="fv-help-block">-->
<!--                              <ErrorMessage name="governorate" />-->
<!--                              <ErrorMessage name="personalInformation.government" />-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;end::Input group&ndash;&gt;-->
<!--                      </div>-->
                    </div>


                    <!--begin::Actions-->
                    <div class="text-center">
                      <!--begin::Submit button-->
                      <button
                        type="submit"
                        ref="submitButton"
                        id="kt_sign_in_submit"
                        class="btn btn-lg btn-danger   mt-5"
                      >
                        <span class="indicator-label"> {{ $t("update") }} </span>

                        <span class="indicator-progress">
                                    {{ $t("loading") }}
                                    <span
                                      class="spinner-border spinner-border-sm align-middle ms-2"
                                    ></span>
                                  </span>
                      </button>
                      <!--end::Submit button-->


                      <!--                                          <div class="text-center mt-2">-->
                      <!--                                            <div class="alert alert-danger">-->
                      <!--                                              {{ $t('qr_gate') }}-->
                      <!--                                            </div>-->
                      <!--                                            <qrcode-vue :value="securityGateQrCodeDataStr" :size="300" level="H" />-->
                      <!--                                          </div>-->
                    </div>
                    <!--end::Actions-->
                  </Form>
                  <!--end::Form-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cloudsTop"></div>
      </div>
    </div>
  </div>
  <!--end::Wrapper-->
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import AOS from "aos";
import QrcodeVue from "qrcode.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    flatPickr,
    QrcodeVue,
    ErrorMessage
  },
  setup(props, context) {
    const helpers: any = inject("helpers");
    const store = useStore();
    const router = useRouter();
    const i18n = useI18n();
    const { t } = useI18n();

    const user = computed(() => {
      return store.getters["moduleAuth/getAuthUser"];
    });


    Yup.setLocale({
      mixed: {
        required: i18n.t("must_required"),
        number: i18n.t("must_number")
      }
    });

    const state = reactive({
      ImageModel: null,
      ImageLoaderProgress: 0,
      ImageLoader: false,

      nationalities:[],
      loading: false,
      first_name: "",
      middle_name: "",
      last_name: "",
      ssn: "",
      phone: null,
      email: null,
      dob: "",
      gender: "male",
      nationality: "",
      governorate: "",
      image: "",
      securityGateQrCodeDataStr: "",
      insideEgypt: 0
    });

    onMounted(() => {

      store.dispatch("moduleCommon/getCountries", {}).then((data) => {
        state.nationalities = data.data
      });
      AOS.init();
      state.loading = true;
      setTimeout(() => {
        store.dispatch("moduleAuth/verify")
          .then(({ data }) => {
            state.loading = false;
            let response = data.data;
            state.insideEgypt = response.insideEgypt;
            state.email = response.email;
            state.ssn = response.personalInformation.nationalId;
            state.first_name = response.personalInformation.firstName;
            state.middle_name = response.personalInformation.middleName;
            state.last_name = response.personalInformation.lastName;
            state.phone = response.personalInformation.phoneNumber;
            state.image = response.personalInformation.image;
            state.dob = response.personalInformation.dob;
            state.gender = response.personalInformation.gender;
            state.nationality = response.personalInformation.nationality;
            state.governorate = response.personalInformation.government;
            state.securityGateQrCodeDataStr = JSON.stringify(response.securityGateQrCodeData);
          })
          .catch((response) => {
            state.loading = false;
            helpers.handleResponse(response, t, router, store, {});
          });
      }, 1000);
    });

    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      first_name: Yup.string().required(),
      middle_name: Yup.string().required(),
      last_name: Yup.string().required()
    });

    //Form submit function
    const onSubmitLogin = (values, form) => {
      // Clear existing errors
      // store.dispatch(Actions.LOGOUT);

      if (!form) {
        return;
      }

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        submitButton.value.setAttribute("disabled", "true");
      }

      const { setErrors } = form;

      // Dummy delay
      setTimeout(() => {
        // Send login request
        let payload = {
          "dob": state.dob,
          "firstName": state.first_name,
          "middleName": state.middle_name,
          "lastName": state.last_name,
          "image": state.image,
          "gender": state.gender,
          "nationality": state.nationality,
          "government": state.governorate
        };
        store
          .dispatch("moduleAuth/update", payload)
          .then((response) => {
            helpers.successNotify(t("success"), t("success_msg"));
            // location.reload()
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          })
          .catch((response) => {
            if (!helpers) {
              return;
            }
            helpers.handleResponse(response, t, router, store, { setErrors });
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          });

      }, 1000);
    };

    const triggerClickUpdate = () => {
      let element = document.getElementById("imageFile");
      if (element) element.click();
    };
    const handleChangeImage = (evt: Event | any) => {
      let file = evt.target.files[0];
      let payload = new FormData();
      payload.append("path", "UserProfile");
      payload.append("isPublic", "false");
      if (helpers.getUserId()) payload.append("userId", helpers.getUserId());
      payload.append("files", file);
      state.ImageModel = file;
      uploadImage(payload);
    };
    const uploadImage = (payload) => {
      state.ImageLoader = true;
      state.ImageLoaderProgress = 0;
      let config: any = {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: function(progressEvent) {
          let uploadPercentage: number = (Math.round(((progressEvent.loaded / progressEvent.total) * 100)));
          state.ImageLoaderProgress = uploadPercentage;
        }
      };
      let requestData = {
        formData: payload,
        config: config
      };
      setTimeout(() => {
        store.dispatch("moduleCommon/uploadImage", requestData).then(({ data }) => {
          state.ImageLoader = false;
          // state.image = data.filesUrls[0];
          if (data.filesUrls[0]) {
            // state.image = (new URL(data.filesUrls[0])).pathname;
            const queryString = (new URL(data.filesUrls[0])).search;
            const urlParams = new URLSearchParams(queryString);
            let filePath: any = urlParams.get("filePath");
            state.image = filePath;
            ;
          }
          setTimeout(() => {
            state.ImageLoaderProgress = 0;
          }, 1000);
        }).catch((response) => {
          state.ImageLoader = false;
          state.ImageLoaderProgress = 0;
          helpers.handleResponse(response, i18n.t, router, store);
        });
      }, 10);
    };

    return {
      triggerClickUpdate,
      handleChangeImage,
      uploadImage,
      ...toRefs(state),
      onSubmitLogin, i18n, store,
      login,
      user,
      submitButton
    };
  }
});
</script>
<style>
.shimmer, .free-style {
  margin: auto !important;
}
</style>
